export const policyDocumentNameMap: { [key: string]: string } = {
  auto_policy: 'Auto Policy',
  dec_page: 'Policy Summary & Declarations',
  application: 'Application',
  clearcover_privacy_notice: 'Privacy Policy',
  terms_of_service: 'Terms of Service',
  paperless_policy: 'Paperless Billing Policy',
  autopay_policy: 'Auto Pay Policy',

  az_application: 'Arizona Application',
  az_auto_amendatory_endorsement: 'Arizona Auto Amendatory Endorsement',
  az_auto_policy: 'Arizona Auto Policy',
  az_autopay_policy: 'Autopay Disclosure',
  az_bill: 'Bill',
  az_cancel_misrepresentation: 'Policy Cancellation Notice',
  az_cancel_nonpayment: 'Policy Cancellation Notice',
  az_cancel_risk_increase: 'Policy Cancellation Notice',
  az_clearcover_privacy_notice: 'Privacy Policy',
  az_consumer_info_disclosure: 'Consumer Information Disclosure',
  az_dec_page_endorsement: 'Updated Policy Summary & Declarations',
  az_dec_page: 'Policy Summary & Declarations',
  az_excluded_driver_endorsement: 'Excluded Driver Amendment',
  az_full_comp_window_glass_coverage_form:
    'Full Comprehensive Window Glass Coverage Form',
  az_nonrenewal_misrepresentation: 'Policy Nonrenewal Notice',
  az_nonrenewal_nonpayment: 'Policy Nonrenewal Notice',
  az_nonrenewal_risk_increase: 'Policy Nonrenewal Notice',
  az_paperless_policy: 'Paperless Disclosure',
  az_privacy_notice_renewal: 'Privacy Policy',
  az_reinstatement: 'Policy Reinstatement Notice',
  az_rideshare_endorsement_endorsement: 'Ridesharing Coverage Amendment',
  az_rideshare_endorsement_new_business: 'Ridesharing Coverage Amendment',
  az_statement_of_no_loss: 'Statement of No Loss',
  az_terms_of_service: 'Terms of Service',
  az_um_uim_coverage: 'Uninsured/Underinsured Motorist Coverage',
  az_um_uim_selection_form:
    'Uninsured/Underinsured Motorists Coverage Selection Form',
  az_void_notice_nonpayment: 'Policy Void Notice',

  il_application: 'Illinois Application',
  il_auto_policy: 'Illinois Auto Policy',
  il_autopay_policy: 'Autopay Disclosure',
  il_bill: 'Bill',
  il_cancel_misrepresentation: 'Policy Cancellation Notice',
  il_cancel_nonpayment: 'Policy Cancellation Notice',
  il_cancel_risk_increase: 'Policy Cancellation Notice',
  il_clearcover_privacy_notice: 'Privacy Policy',
  il_consumer_info_disclosure: 'Consumer Information Disclosure',
  il_dec_page_endorsement: 'Updated Policy Summary & Declarations',
  il_dec_page: 'Policy Summary & Declarations',
  il_excluded_driver_endorsement: 'Excluded Driver Amendment',
  il_nonrenewal_misrepresentation: 'Policy Nonrenewal Notice',
  il_nonrenewal_nonpayment: 'Policy Nonrenewal Notice',
  il_nonrenewal_risk_increase: 'Policy Nonrenewal Notice',
  il_paperless_policy: 'Paperless Disclosure',
  il_privacy_notice_renewal: 'Privacy Policy',
  il_reinstatement: 'Policy Reinstatement Notice',
  il_rideshare_endorsement_new_business: 'Ridesharing Coverage Amendment',
  il_statement_of_no_loss: 'Statement of No Loss',
  il_terms_of_service: 'Terms of Service',
  il_void_notice_nonpayment: 'Policy Void Notice',

  ut_application: 'Utah Application',
  ut_auto_amendatory_endorsement: 'Utah Auto Amendatory Endorsement',
  ut_auto_policy: 'Utah Auto Policy',
  ut_autopay_policy: 'Autopay Disclosure',
  ut_bill: 'Bill',
  ut_cancel_misrepresentation: 'Policy Cancellation Notice',
  ut_cancel_nonpayment: 'Policy Cancellation Notice',
  ut_cancel_risk_increase: 'Policy Cancellation Notice',
  ut_clearcover_privacy_notice: 'Privacy Policy',
  ut_dec_page_endorsement: 'Updated Policy Summary & Declarations',
  ut_dec_page: 'Policy Summary & Declarations',
  ut_excluded_driver_endorsement: 'Excluded Driver Amendment',
  ut_nonrenewal_misrepresentation: 'Policy Nonrenewal Notice',
  ut_nonrenewal_nonpayment: 'Policy Nonrenewal Notice',
  ut_nonrenewal_risk_increase: 'Policy Nonrenewal Notice',
  ut_paperless_policy: 'Paperless Disclosure',
  ut_pip_coverage_selection_form:
    'Personal Injury Protection Coverage Selection Form',
  ut_privacy_notice_renewal: 'Privacy Policy',
  ut_reinstatement: 'Policy Reinstatement Notice',
  ut_rideshare_endorsement_new_business: 'Ridesharing Coverage Amendment',
  ut_statement_of_no_loss: 'Statement of No Loss',
  ut_terms_of_service: 'Terms of Service',
  ut_um_uim_coverage: 'Uninsured/Underinsured Motorist Coverage',
  ut_um_uim_selection_form:
    'Uninsured/Underinsured Motorists Coverage Selection Form',
  ut_void_notice_nonpayment: 'Policy Void Notice',

  oh_application: 'Ohio Application',
  oh_auto_amendatory_endorsement: 'Ohio Auto Amendatory Endorsement',
  oh_auto_policy: 'Ohio Auto Policy',
  oh_autopay_policy: 'Autopay Disclosure',
  oh_bill: 'Bill',
  oh_cancel_misrepresentation: 'Policy Cancellation Notice',
  oh_cancel_nonpayment: 'Policy Cancellation Notice',
  oh_cancel_risk_increase: 'Policy Cancellation Notice',
  oh_clearcover_privacy_notice: 'Privacy Policy',
  oh_dec_page_endorsement: 'Updated Policy Summary & Declarations',
  oh_dec_page: 'Policy Summary & Declarations',
  oh_excluded_driver_endorsement: 'Excluded Driver Amendment',
  oh_nonrenewal_misrepresentation: 'Policy Nonrenewal Notice',
  oh_nonrenewal_nonpayment: 'Policy Nonrenewal Notice',
  oh_nonrenewal_risk_increase: 'Policy Nonrenewal Notice',
  oh_paperless_policy: 'Paperless Disclosure',
  oh_privacy_notice_renewal: 'Privacy Policy',
  oh_reinstatement: 'Policy Reinstatement Notice',
  oh_rideshare_endorsement_new_business: 'Ridesharing Coverage Amendment',
  oh_statement_of_no_loss: 'Statement of No Loss',
  oh_terms_of_service: 'Terms of Service',
  oh_um_uim_coverage: 'Uninsured/Underinsured Motorist Coverage',
  oh_um_uim_selection_form:
    'Uninsured/Underinsured Motorists Coverage Selection Form',
  oh_void_notice_nonpayment: 'Policy Void Notice',

  tx_application: 'Texas Application',
  tx_auto_amendatory_endorsement: 'Texas Auto Amendatory Endorsement',
  tx_auto_policy: 'Texas Auto Policy',
  tx_autopay_policy: 'Autopay Disclosure',
  tx_bill: 'Bill',
  tx_cancel_misrepresentation: 'Policy Cancellation Notice',
  tx_cancel_nonpayment: 'Policy Cancellation Notice',
  tx_cancel_risk_increase: 'Policy Cancellation Notice',
  tx_clearcover_privacy_notice: 'Privacy Policy',
  tx_dec_page_endorsement: 'Updated Policy Summary & Declarations',
  tx_dec_page: 'Policy Summary & Declarations',
  tx_excluded_driver_endorsement: 'Excluded Driver Amendment',
  tx_nonrenewal_misrepresentation: 'Policy Nonrenewal Notice',
  tx_nonrenewal_nonpayment: 'Policy Nonrenewal Notice',
  tx_nonrenewal_risk_increase: 'Policy Nonrenewal Notice',
  tx_paperless_policy: 'Paperless Disclosure',
  tx_privacy_notice_renewal: 'Privacy Policy',
  tx_reinstatement: 'Policy Reinstatement Notice',
  tx_rideshare_endorsement_new_business: 'Ridesharing Coverage Amendment',
  tx_statement_of_no_loss: 'Statement of No Loss',
  tx_terms_of_service: 'Terms of Service',
  tx_um_uim_coverage: 'Uninsured/Underinsured Motorist Coverage',
  tx_um_uim_selection_form:
    'Uninsured/Underinsured Motorists Coverage Selection Form',
  tx_void_notice_nonpayment: 'Policy Void Notice',
  tx_pip_selection_form: 'Personal Injury Protection Coverage Selection Form',
  tx_pip_coverage: 'Personal Injury Protection Coverage',
  tx_consumer_complaint_notice: 'Consumer Complaint Notice',
} as const;

/**
 * To create a state-specific name map, prefix key with 2-letter abbreviation
 * and an underscore: 'il_name_map' for Illinois
 *
 * If there is not a state-specific key match, then looks for a key match
 * without the state prefix: 'name_map' is the generic version
 *
 * If no match is found, the same string passed in is returned
 */
export const getPolicyDocumentName = (defaultName: string): string => {
  if (defaultName in policyDocumentNameMap) {
    return policyDocumentNameMap[defaultName];
  }
  const regex = /^(\w{2}_)(.*)/;
  const regexResult = regex.exec(defaultName);
  if (regexResult && regexResult[2] in policyDocumentNameMap) {
    return policyDocumentNameMap[regexResult[2]];
  }
  return defaultName;
};
